<template>
  <div>
    <PageHeader />
    <PageContent>
      <template #filterBar>
        <form @submit.prevent="setFilter">
          <h6 class="heading-small text-muted mb-4">Search</h6>
          <div class="row">
            <div class="col">
              <a-input placeholder="Search by" v-model="table.filters.name">
                <a-select
                  slot="addonAfter"
                  default-value="name"
                  style="width: 80px"
                >
                  <a-select-option value="name"> Name </a-select-option>
                </a-select>
              </a-input>
            </div>
          </div>
          <hr />
          <h6 class="heading-small text-muted mb-4">Filter by Status</h6>
          <div class="row">
            <div class="col">
              <a-radio-group
                v-model="table.filters.status_code"
                :default-value="null"
                @change="setFilter"
              >
                <a-radio :style="radio.style" :value="null"> All </a-radio>
                <a-radio :style="radio.style" value="A"> Active </a-radio>
                <a-radio :style="radio.style" value="I"> Inactive </a-radio>
              </a-radio-group>
            </div>
          </div>
        </form>
      </template>

      <template #pageTable>
        <PageTable
          :tableTitle="table.title"
          :apiUrl="table.apiUrl"
          :tableFields="table.fields"
          :appendedParams="table.filters"
          :sortOrder="table.sortOrder"
        >
          <template #headerButtons>
            <base-button
              id="new"
              class="float-right ml-1"
              type="primary"
              size="sm"
              v-if="selectedActions.includes('Add')"
              @click="openDrawer()"
              >+ Add Customer Type
            </base-button>
          </template>

          <template #formDrawer>
            <a-drawer
              :width="drawer.width"
              :placement="drawer.placement"
              :visible="drawer.visible"
              @close="closeDrawer"
            >
              <CustomerTypeForm
                :viewMode="viewMode"
                :customerTypeData="customerTypeData"
                @closeDrawer="closeDrawer"
              />
            </a-drawer>
          </template>

          <template #tableButtons="{ tableProps }">
            <div class="d-flex justify-content-around">
              <button
                id="view"
                class="btn btn-success btn-sm w-100"
                v-if="selectedActions.includes('View')"
                @click.prevent="openDrawer(tableProps.rowData)"
              >
                View
              </button>
              <button
                id="edit"
                class="btn btn-warning btn-sm w-100"
                v-if="selectedActions.includes('Edit')"
                @click.prevent="openDrawer(tableProps.rowData)"
              >
                Edit
              </button>
              <a-popconfirm
                title="You are about to delete this record?"
                v-if="
                  selectedActions.includes('Delete') &&
                  !tableProps.rowData.member_count
                "
                @confirm="deleteRow(tableProps.rowData)"
                okText="Delete"
                cancelText="Cancel"
              >
                <a class="btn btn-danger btn-sm text-white w-100">Delete</a>
              </a-popconfirm>
            </div>
          </template>
        </PageTable>
      </template>
    </PageContent>
  </div>
</template>

<script>
import PageHeader from '../../components/Page/Header.vue';
import PageContent from '../../components/Page/Content.vue';
import PageTable from '../../components/Page/Table.vue';
import CustomerTypeForm from './CustomerTypeForm.vue';
import { mapGetters } from 'vuex';
import HTTPRequest from '@/controllers/httpRequest';

export default {
  components: {
    PageHeader,
    PageContent,
    PageTable,
    CustomerTypeForm
  },
  data() {
    return {
      // selectedActions: [],
      customerTypeData: null,
      drawer: {
        visible: false,
        width: 480,
        placement: 'right'
      },
      viewMode: false,
      table: {
        title: 'Customer Type',
        apiUrl: '/api/v1/customer_types',
        fields: [
          'actions',
          { name: 'membershipProgram.name', title: 'Membership Program' },
          'name',
          'description',
          {
            name: 'status',
            title: 'Status',
            formatter(value) {
              return value === 'A' ? 'Active' : 'Inactive';
            }
          }
        ],
        filters: {
          status: null,
          name: null
        },
        sortOrder: [
          {
            field: 'id',
            direction: 'desc'
          }
        ]
      },

      radio: {
        style: {
          display: 'block',
          height: '35px',
          lineHeight: '30px'
        }
      }
    };
  },
  computed: {
    ...mapGetters({
      selectedActions: 'getModuleSelectedActions'
    })
  },
  methods: {
    openDrawer(rowData = null) {
      this.viewMode = event.target.id == 'view' ? true : false;
      this.customerTypeData = rowData;
      this.drawer.visible = true;
    },

    closeDrawer() {
      this.drawer.visible = false;
      this.customerTypeData = null;
    },

    setFilter() {
      this.$root.$emit('refreshTable');
    },
    async deleteRow(rowData) {
      const id = rowData.id;
      const response = await HTTPRequest.deleteRequest(
        `/api/v1/customer_types/${id}`
      );

      if (response.message == 'Success') {
        this.$notification.success({
          message: 'Success'
        });
        this.$root.$emit('refreshTable');
      } else {
        if (response.error != undefined) {
          this.$notification.error({
            message: response.error
          });
        } else {
          this.$notification.error({
            message: 'Something went wrong. Please try again.'
          });
        }
      }
    }
  },

  created() {
    this.$store.dispatch('setCurrentModule', 'CustomerType');
  },
  mounted() {
    this.selectedActions = this.$store.getters.getModuleSelectedActions;
  }
};
</script>

<style scoped></style>
